import { MenuItem } from "./menu";
import { ApplicationContextService } from "../../../ServiceDesk/sdServices/context/application-context-service";

export class PoppableMenuHarnessController {
  public simpleitemsMock: MenuItem[];
  public complexitemsMock: MenuItem[];
  public agentProfileCarditemsMock: MenuItem[];
  public profileImgUrl: string;
  public agentName: string;
  public agentPresenceGlyph: string;
  public agentPresenceString: string;
  // @ngInject
  constructor(private applicationContextService: ApplicationContextService) {
    // Setup simple example
    this.simpleitemsMock = [
      {
        displayName: "Main Menu Item1"
      },
      {
        displayName: "Main Menu Item2"
      },
      {
        displayName: "Main Menu Item3"
      }
    ];
    // Setup complex example
    this.complexitemsMock = [
      {
        displayName: "Main Menu Item1",
        glyph: "sd-glyph-agent-available"
      },
      {
        displayName: "Main Menu Item2"
      },
      {
        displayName: "Main Menu Item3",
        subItems: [
          {
            displayName: "Sub Menu Item1"
          },
          {
            displayName: "Sub Menu Item2"
          },
          {
            displayName: "Sub Menu Item3"
          },
          {
            displayName: "Sub Menu Item4"
          }
        ]
      },
      {
        displayName: "Main Menu Item4"
      },
      {
        displayName: "Main Menu Item5",
        subItems: [
          {
            displayName: "Sub Menu Item1"
          },
          {
            displayName: "Sub Menu Item2"
          },
          {
            displayName: "Sub Menu Item3"
          },
          {
            displayName: "Sub Menu Item4"
          }
        ]
      }
    ];
    // Setup agent profile card example
    this.agentProfileCarditemsMock = [
      {
        displayName: "Available",
        onClick: () => {
          this.agentPresenceGlyph = "sd-glyph-agent-available";
          this.agentPresenceString = "Available";
        },
        glyph: "sd-glyph-agent-available"
      },
      {
        displayName: "Busy",
        onClick: () => {
          this.agentPresenceGlyph = "sd-glyph-agent-busy";
          this.agentPresenceString = "Busy";
        },
        glyph: "sd-glyph-agent-busy"
      },
      {
        displayName: "Away",
        glyph: "sd-glyph-agent-away",
        subItems: [
          {
            displayName: "Lunch",
            onClick: () => {
              this.agentPresenceGlyph = "sd-glyph-agent-away";
              this.agentPresenceString = "Lunch";
            },
            glyph: "sd-glyph-agent-away"
          },
          {
            displayName: "Break",
            onClick: () => {
              this.agentPresenceGlyph = "sd-glyph-agent-away";
              this.agentPresenceString = "Break";
            },
            glyph: "sd-glyph-agent-away"
          },
          {
            displayName: "Training",
            onClick: () => {
              this.agentPresenceGlyph = "sd-glyph-agent-away";
              this.agentPresenceString = "Training";
            },
            glyph: "sd-glyph-agent-away"
          },
          {
            displayName: "Meeting",
            onClick: () => {
              this.agentPresenceGlyph = "sd-glyph-agent-away";
              this.agentPresenceString = "Meeting";
            },
            glyph: "sd-glyph-agent-away"
          }
        ]
      },
      {
        displayName: "Sign Out"
      }
    ];

    this.agentPresenceGlyph = "sd-glyph-agent-available";
    this.agentPresenceString = "Available";
    this.profileImgUrl = this.applicationContextService.appContext.agentProfileImageUrl;
    if (this.applicationContextService.appContext.agentDisplayName) {
      this.agentName = this.applicationContextService.appContext.agentDisplayName;
    }
  }
}
